import { isRunningInNativeCapacitorApp } from 'src/util/platform/browserInteractionCapabilities';

export function bootServiceWorkerRegistration(): void {
	if (process.env.DEV) {
		return;
	}

	if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
		return;
	}

	if (isRunningInNativeCapacitorApp()) {
		return;
	}

	void import('../../src-pwa/register-service-worker');
}
